<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Platform Distribution</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-ctv-platform-distribution [data]="data"></app-ctv-platform-distribution>
    </div>
  </div>
</div>
